// extracted by mini-css-extract-plugin
module.exports = {"myfacebookbuttonclass":"style_myfacebookbuttonclass__22KLL"};